import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckDetails } from '@api/consistencyCheck';

import { IComparisonId } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TConsistencyCheckDetailsDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_DETAILS } from '@constants/queryKeys';

const useQueryConsistencyCheckDetailsFetch = (params: TConsistencyCheckDetailsDTO & IComparisonId) => {
	const {
		comparisonId,
		page,
		pageSize,
		sortDirection,
		sortFieldName,
		siteId,
		paramName,
		delta,
		searchValue,
		managedObjects,
		configId,
		gnbId,
	} = params;

	const {
		data: details,
		isLoading: isLoadingBranch,
		isFetching: isFetchingBranch,
	} = useQuery({
		queryKey: [
			CONSISTENCY_DETAILS,
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			siteId,
			configId,
			gnbId,
			comparisonId,
			searchValue,
			paramName,
			delta,
			managedObjects,
		],
		queryFn: () => {
			return getConsistencyCheckDetails(comparisonId, {
				page,
				pageSize,
				sortDirection,
				sortFieldName: sortFieldName?.replace('_', '.'),
				paramName,
				siteId,
				delta,
				searchValue,
				managedObjects,
				configId,
				gnbId,
			});
		},
		enable: [comparisonId],
		...refetchOptions,
	});

	const rows = details?.rows || { items: [], count: 0 };

	return {
		isLoadingDetails: isLoadingBranch || isFetchingBranch,
		details: rows.items,
		countOfRecords: rows.count,
		dataSourceCreatedAt: details?.dataSourceCreatedAt,
	};
};

export default useQueryConsistencyCheckDetailsFetch;
